import Image, { ImageProps } from "next/image";
import React from "react";

/**
 * Purpose - Function to check if image is coming from AEM so that we can rely on Next js default image optimization.
 * If the image is not from AEM, we will skip Next.js optimization to avoid issues
 * @param src
 * @returns
 */
const isAemUrl = (src: ImageProps["src"]): src is string => {
  if (typeof src !== "string") return false;
  try {
    const url = new URL(src);
    return url.hostname.includes("aem") || url.hostname.includes("adobe");
  } catch {
    return false;
  }
};

const isExternalUrl = (src: ImageProps["src"]): src is string => {
  return typeof src === "string" && /^https?:\/\//.test(src);
};

function fixImageUrl(url: string) {
  // Replace double slashes "//" with single slash "/" after the domain part of the URL
  return url.replace(/([^:]\/)\/+/g, "$1");
}

const ImageWrapper: React.FC<ImageProps> = (props) => {
  const { src, alt = "", optimize=false, ...rest } = props;

  const shouldUnoptimize = isExternalUrl(src) && !isAemUrl(src) || optimize;

  const imagesrc = !shouldUnoptimize && typeof src === "string" ? fixImageUrl(src) : src;

  return (
    <Image
      src={imagesrc}
      alt={alt || 'sobeys'}
      {...rest}
      unoptimized={shouldUnoptimize}
    />
  );
};

export default ImageWrapper;
